var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLadder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 48,
    viewBox: "0 0 8 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rungs",
    fill: "#777"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 3,
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9,
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15,
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21,
    width: 8,
    height: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "side",
    fill: "#555"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1.5,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 0,
    width: 1.5,
    height: 24
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLadder);
export default __webpack_public_path__ + "static/media/ladder.8741034dfb57f8ce3aee419ba01a4ee2.svg";
export { ForwardRef as ReactComponent };